<p-button icon="fas fa-upload" [label]="app.t('general.uploadFile')" (onClick)="upload()">
</p-button>
<p-tag *ngIf="value != null && value.length > 0" class="ml-3" severity="success" value="Angehängt"></p-tag>